/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';

export function FlexRow({align, ...props} /*: any */) /*: React$Node */ {
  let className = 'u-flex-row';

  if (align) {
    className = `${className} u-flex-align-${align}`;
  }
  return html`
    <div className=${`${className} ${props.className || ''}`} ...${props} />
  `;
}
